import { ReactNode } from 'react';
import { defineMessage } from 'react-intl';

import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';

import { PoweredByWatermark, NavigationBar, Page, PageContent } from '@ocx/ui';

type FuelingStatusLayoutProps = {
  children: ReactNode;
};

export const FuelingStatusLayout = ({ children }: FuelingStatusLayoutProps) => {
  return (
    <Page>
      <HtmlTitle
        title={defineMessage({
          id: 'fuelingStatus:htmlTitle',
          defaultMessage: 'Fueling Status',
          description:
            'HTML title tag for Fueling Status page where user see current status of fueling: Authorizing pump/Begin fueling/Fueling started',
        })}
      />
      <NavigationBar center={<VendorLogo />} />
      <PageContent bgcolor="background.paper">
        {children}
        <PoweredByWatermark />
      </PageContent>
    </Page>
  );
};
